import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AsyncStbButton from '../../../../atoms/button/AsyncStbButton';
import CheckCircleTwoTone from '@ant-design/icons/CheckCircleTwoTone';
import SelfControlContainer from '../../../../organisms/selfcontrolcontainer/SelfControlContainer';
import type { SelfControlContainerDto as SelfControlContainerModel } from '../../../../../api/generated/model/selfControlContainerDto';

interface SelfControlAccordionItemProps {
  projectId: number;
  selfControlContainerData: SelfControlContainerModel | undefined;
  setSelfControlContainerData: React.Dispatch<React.SetStateAction<SelfControlContainerModel | undefined>>;
  selfControlCompletionStatus: boolean;
  onSign: () => Promise<void>;
}

const completionIcon = (
  <CheckCircleTwoTone
    twoToneColor="#52c41a"
    style={{ fontSize: '25px', marginLeft: '10px' }}
  />
);

const SelfControlAccordionItem: React.FC<SelfControlAccordionItemProps> = ({
  projectId,
  selfControlContainerData,
  setSelfControlContainerData,
  selfControlCompletionStatus,
  onSign,
}) => {
  return (
    <>
      {selfControlContainerData &&
        <Accordion.Item className='accordion-item shadow fw-bold' eventKey="4" >
          <Accordion.Header>
            Egenkontroll Ställning
            {selfControlCompletionStatus ? completionIcon : null}
          </Accordion.Header>
          <Accordion.Body >
            <SelfControlContainer
              projectId={projectId}
              selfControlContainer={selfControlContainerData}
              setSelfControlContainer={setSelfControlContainerData}
              onUpdate={() => undefined}
            />
            <div className="stb-action-bar">
              <AsyncStbButton type="button" variant="primary" onClick={onSign}>
                Signera egenkontroll
              </AsyncStbButton>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      }
    </>
  );
};

export default SelfControlAccordionItem;
